import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const Collections = () => {
  const navigate = useNavigate();
  const idOrganisation = localStorage.getItem("idOrganisation");
  const [collections, setCollections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCollections = async () => {
      if (!idOrganisation) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(
          "https://backend-betkiff.vercel.app/collections/getCollections",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ idOrganisation }),
          }
        );

        if (!response.ok) {
          throw new Error(`Erreur HTTP : ${response.status}`);
        }

        const dataCollection = await response.json();
        console.log("Collections récupérées :", dataCollection);

        const formattedData = dataCollection
          ? Object.entries(dataCollection).map(([key, value]) => ({
              id: key,
              ...value,
            }))
          : [];

        setCollections(formattedData);
      } catch (error) {
        console.error("Erreur :", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCollections();
  }, [idOrganisation]);

  return (
    <Box
      sx={{
        position: "fixed",
        height: "100vh",
        width: "100vw",
        padding: "9vh 3vw 7vh 3vw",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <IconButton onClick={() => navigate("/dashboard")}>
          <ArrowBackIosIcon
            sx={{ color: "rgba(90, 20, 121, 0.9)", fontSize: 30 }}
          />
        </IconButton>
        <Paper
          elevation={3}
          sx={{
            border: "2px solid rgba(90, 20, 121, 0.7)",
            backgroundColor: "transparent",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => navigate("/createcollection")}
        >
          <AddIcon sx={{ fontSize: 30, color: "rgba(90, 20, 121, 0.9)" }} />
        </Paper>
      </Box>

      <Typography
        variant="h1"
        sx={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          width: "100%",
        }}
      >
        Espace collections
      </Typography>
      <Typography
        variant="caption"
        sx={{
          fontSize: "1rem",
          color: "rgba(90, 20, 121, 254)",
          width: "100%",
          display: "block",
        }}
      >
        Choisis en une pour ajouter une carte !
      </Typography>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ flexGrow: 1, marginTop: "20px" }}>
          <Grid container spacing={2}>
            {collections.length > 0 ? (
              collections.map((collection) => (
                <Grid
                  item
                  xs={6}
                  key={collection.id}
                  sx={{ minHeight: "220px" }}
                >
                  <Paper
                    elevation={3}
                    sx={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      position: "relative",
                      backgroundColor: collection?.collectionImageUrl
                        ? "black"
                        : "transparent",
                      borderRadius: "15px",
                      overflow: "hidden",
                      cursor: "pointer",
                      transition: "background-color 0.3s ease",
                      "&:hover": {
                        backgroundColor: collection?.collectionImageUrl
                          ? "black"
                          : "rgba(90, 20, 121, 0.1)",
                      },
                    }}
                    onClick={() => {
                      localStorage.setItem(
                        "selectedCollectionName",
                        collection.nameCollection
                      );
                      navigate(`/addcards/${collection.id}`);
                    }}
                  >
                    {/* Image de fond si disponible */}
                    {collection.collectionImageUrl && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundImage: `url(${collection.collectionImageUrl})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          opacity: 0.5,
                        }}
                      />
                    )}

                    {/* Nom de la collection */}
                    <Typography
                      sx={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        mt: 1,
                        color: "white",
                        position: "relative",
                        zIndex: 1,
                      }}
                    >
                      {collection.nameCollection}
                    </Typography>
                  </Paper>
                </Grid>
              ))
            ) : (
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  color: "#e1bfe4",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                Aucune collection trouvée.
              </Typography>
            )}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default Collections;
